module.exports = __webpack_public_path__ + "18f44903178d5e3e5110f0d4f0d97f13.svg";